import { render } from "./ShowFactura.vue?vue&type=template&id=7a5f1ad1"
import script from "./ShowFactura.vue?vue&type=script&lang=js"
export * from "./ShowFactura.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__